// Map score part names to localized voice names, keyed off the first letter.
// Handles both Latin (S, A, T, B) and Cyrillic (С, А, Т, Б) initials, since
// some of our scores label parts in Russian. Note the Cyrillic letters are
// distinct code points from their Latin look-alikes.

const FIRST_LETTER_TO_VOICE = {
  'S': 'soprano',
  'A': 'alto',
  'T': 'tenor',
  'B': 'bass',
  'С': 'soprano',
  'А': 'alto',
  'Т': 'tenor',
  'Б': 'bass'
};

/**
 * Get the canonical voice key ('soprano' | 'alto' | 'tenor' | 'bass') for a
 * raw part name from the score, or null if it doesn't look like a voice part.
 */
export function getVoiceKey(rawName) {
  if (!rawName) return null;
  const firstLetter = String(rawName).trim().match(/\p{L}/u);
  if (!firstLetter) return null;
  return FIRST_LETTER_TO_VOICE[firstLetter[0].toUpperCase()] || null;
}

/**
 * Translate a raw part name into the user's selected language, preserving a
 * trailing part number (e.g. "Сопрано 1" -> "Soprano 1"). Falls back to the
 * raw name when the part isn't recognizable as a voice part.
 */
export function getLocalizedPartName(rawName, t) {
  const voiceKey = getVoiceKey(rawName);
  if (!voiceKey) return rawName;

  const translated = t(`parts.${voiceKey}`);
  const trailingNumber = String(rawName).match(/(\d+)\s*$/);
  return trailingNumber ? `${translated} ${trailingNumber[1]}` : translated;
}
